import * as React from 'react';
import { clsx } from 'clsx';
import { UIHeading4 } from '@cian/ui-kit';
import { IconFunctionalHouse16, IconToggleHeartOn12 } from '@cian/ui-kit-design-tokens/icons';

import { INewbuildingMapPin } from '../../../../types/map';
import * as styles from './styles.css';

export interface IMobileMapPinProps {
  pin: INewbuildingMapPin;
  isSeen?: boolean;
  onClick(pin: INewbuildingMapPin): void;
}

export const MobileMapPin = ({ pin, isSeen, onClick }: IMobileMapPinProps): React.JSX.Element => {
  const handleClick = React.useCallback(() => {
    onClick(pin);
  }, [onClick, pin]);

  return (
    <div className={clsx(styles['wrapper'], isSeen && styles['wrapper--seen'])}>
      <a
        className={clsx(styles['balloon'], isSeen && styles['balloon--seen'])}
        data-testid="newbuildings-map-mobile-pin"
        href={pin.newbuilding.fullUrl}
        rel="noreferrer"
        target="_blank"
        onClick={handleClick}
      >
        <span className={styles['icon']}>
          <IconFunctionalHouse16 color="icon-inverted-default" />
        </span>
        <span className={styles['title']}>
          <UIHeading4 color={isSeen ? 'text-secondary-default' : undefined}>{pin.title}</UIHeading4>
        </span>
        {pin.newbuilding.isFavorite && (
          <span className={styles['favorite']} data-testid="newbuildings-map-mobile-pin-favorite">
            <IconToggleHeartOn12 color="icon-negative-default" />
          </span>
        )}
      </a>
      <span className={styles['point']} />
    </div>
  );
};
